/**
 * Copyright (c) 2018-2019 Aleksey Melnikov, True Directive Company.
 * @link https://truedirective.com/
 * @license MIT
*/
import { Component, Renderer2, ViewChild } from '@angular/core';

import { ColumnType } from '@true-directive/base';
import { Column } from '@true-directive/base';
import { FilterOperator, Filter } from '@true-directive/base';
import { NumberFormat } from '@true-directive/base';
import { NumberParserFormatter } from '@true-directive/base';

import { FilterBaseComponent } from './filter-base.component';
import { InternationalizationService } from '../../internationalization/internationalization.service';

@Component({
  selector: 'true-filter-number',
  templateUrl: 'filter-number.component.html',
  styleUrls: ['filter-number.component.scss']
})
export class FilterNumberComponent extends FilterBaseComponent {

  // IFilter implementation
  // Initialization
  protected firstFocus() {
    setTimeout(() => {
      this.selectMode = this.filter.operator === FilterOperator.SET ? true : null;
      this.input1.nativeElement.select();
      this.input1.nativeElement.focus();
    }, 10);
  }

  public init() {
    this.firstFocus();
  }

  // ÐÑÐ¸Ð±ÐºÐ° Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¾Ð³Ð¾ Ð²Ð²Ð¾Ð´Ð°
  inputError1: string = '';
  inputError2: string = '';
  gridError: string = '';

  // Validation
  public validate(): boolean {
    this.inputError1 = '';
    this.inputError2 = '';
    this.gridError = '';

    // Ð§Ð¸ÑÑÐ¸Ð¼ ÑÐ¿Ð¸ÑÐ¾Ðº Ð·Ð½Ð°ÑÐµÐ½Ð¸Ð¹ Ð² ÑÐ¸Ð»ÑÑÑÐµ
    this.filter.items.splice(0, this.filter.items.length);

    let checkedItems: any[] = []

    if (this.filter.value === null) {
      this.inputError1 = 'Enter first number';
    }

    if (this.filter.value2 === null) {
      this.inputError2 = 'Enter second number';
    }

    if (this.inputError1 != '' || this.inputError2 != '') {
      return false;
    }

    if (this.selectMode) {
      // ÐÐ¾Ð±Ð°Ð²Ð»ÑÐµÐ¼ Ð¾ÑÐ¼ÐµÑÐµÐ½Ð½ÑÐµ Ð¿ÑÐ¸ ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²ÑÑÑÐµÐ¼ ÑÐµÐ¶Ð¸Ð¼Ðµ
      this.filter.items.splice(0, this.filter.items.length);
      checkedItems.filter(i => i.checked).forEach(i => this.filter.items.push(i.item));
    }

    return true;
  }

  getFormat() {
    if (this.filter.format && this.filter.format != '')
      return this.filter.format;
    return '{1-9.0-4}';
  }

  selectMode: boolean = null;

  operators = [
    FilterOperator.BETWEEN,
    FilterOperator.NOT_BETWEEN
  ];

  @ViewChild('input1', {static: true}) input1: any;
  @ViewChild('input2', {static: true}) input2: any;
  @ViewChild('grid', {static: true}) grid: any;

  public listColumns: Column[] = [
    new Column('checked', 'Checked', 32, ColumnType.CHECKBOX, ''), // Ð Ð½ÐµÐºÐ¾ÑÐ¾ÑÑÑ Ð¼ÐµÑÑÐ°Ñ ÑÐµÑÐºÐ¾ Ð·Ð°Ð´Ð°Ð½Ð¾ 28
    new Column('item', '(All)', 300, ColumnType.NUMBER, ''),
    new Column('group', 'group', 5, ColumnType.NUMBER, '')
  ];

  public groupedColumns: Column[] = [
    this.listColumns[2]
  ];

  private getNumFormat(fmt: string): NumberFormat {
    if (fmt === '') {
      fmt = '{1.0-2}';
    }
    return NumberFormat.parseFormat(fmt);
  }

  private displayedValue(v: number) {
    let nf = this.getNumFormat(this.filter.format);
    return NumberParserFormatter.format(v, nf, this.intl.locale.separators);
  }

  inputFocus(e: any) {
    const txt = e.target.value;
    this._renderer.setProperty(e.target, 'selectionStart', 0);
    this._renderer.setProperty(e.target, 'selectionEnd', txt.length);
  }

  constructor(
    protected _renderer: Renderer2,
    protected intl: InternationalizationService) {
    super(intl);
  }
}
